export const MSK_DELIVERY_MODE_FACTORY_TO_CLIENT = "factory_to_client";

export const MSK_DELIVERY_MODE_FACTORY_TO_CLIENT_OPTION = {
  value: MSK_DELIVERY_MODE_FACTORY_TO_CLIENT,
  label: "от завода до клиента",
};
